import type { UseContentfulPageResponseModel } from '~/composables/useContentfulPage';

export const usePreloadedContentfulPage = () => {
  return useState<UseContentfulPageResponseModel | null>(
    'preloadedcontentfulpage',
    () => null
  );
};
